import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() label = '';
  @Input() isDisabled = false;
  @Input() loading = false;
  @Input() style: any = {};
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  click = () => this.onClick.emit();
}
